import React from 'react';
import ReviewComment from './review_comment';
import ModalConfirm from '../../../modal/hooks/modal_comfirm';
import ModalAlert from '../../../modal/modal_alert';
import axios from '../../../axios';

const Review = ({
  review,
  currentUser = null,
  isFormShow = false,
  isCircleManager = false,
}) => {
  const [isDeleted, setIsDeleted] = React.useState(false);
  const confirmModalRef = React.useRef(null);
  const alertModalRef = React.useRef(null);
  const deleteConfirmModalRef = React.useRef(null);
  const deleteAlertModalRef = React.useRef(null);
  const managerDeleteConfirmModalRef = React.useRef(null);
  const managerDeleteAlertModalRef = React.useRef(null);

  const openConfirmModal = React.useCallback(() => {
    confirmModalRef.current.openModal();
  }, []);

  // @context TGW-2035 本人以外のレビューでも、サークル管理人であれば「削除する」を出す。
  //   本人削除は既存モーダル文言のまま、管理人削除だけ抑制文言(運営チームに送られる旨)を付ける。
  const isOwnReview =
    currentUser && review.user && currentUser.id === review.user.id;

  if (isDeleted) return null;

  return (
    <li key={review.id}>
      <div className="row">
        <div className="col">
          <div className="row pl-3 mt-1 mb-1">
            <img
              src={
                review.company
                  ? review.companies_user
                    ? review.companies_user.avatar_thumb
                    : ''
                  : review.user
                    ? review.user.avatar_thumb
                    : ''
              }
              className="event-member-icon-small"
            />
            <div className="pl-3">
              <p className="text-fz-14px text-black-50 mb-0">
                @
                {review.company
                  ? review.companies_user
                    ? review.company.is_real_name_required
                      ? review.companies_user.view_full_name_disp
                      : review.companies_user.nickname
                    : '退会ユーザー'
                  : review.user
                    ? review.user.tunagate_id
                    : '退会ユーザー'}
              </p>
            </div>
          </div>
        </div>
        <div className="col dropdown dropleft">
          <img
            style={{ padding: '0 2px 0 12px' }}
            id="dropdownMenu"
            className="position-absolute position--headerright text-black-50 text-fz-14px"
            data-toggle="dropdown"
            src="/assets2019/img/icon_reader.svg"
            alt=""
          />
          <div className="dropdown-menu" aria-labelledby="dropdownMenu">
            {isOwnReview ? (
              <button
                onClick={() => deleteConfirmModalRef.current.openModal()}
                className="dropdown-item btn btn-light text-danger text-center"
                type="button"
              >
                削除する
              </button>
            ) : (
              <>
                <button
                  onClick={() => openConfirmModal()}
                  className="dropdown-item btn btn-light text-primary text-center"
                  type="button"
                >
                  通報する
                </button>
                {isCircleManager && (
                  <button
                    onClick={() =>
                      managerDeleteConfirmModalRef.current.openModal()
                    }
                    className="dropdown-item btn btn-light text-danger text-center"
                    type="button"
                  >
                    削除する
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <p className="text-fz-14px text-black-50 pb-0 line-1 mb-0">
        {review.score > 0 && (
          <span>
            <span style={{ color: review.score >= 1 ? '#ffd700' : '#ccc' }}>
              ★
            </span>
            <span style={{ color: review.score >= 2 ? '#ffd700' : '#ccc' }}>
              ★
            </span>
            <span style={{ color: review.score >= 3 ? '#ffd700' : '#ccc' }}>
              ★
            </span>
            <span style={{ color: review.score >= 4 ? '#ffd700' : '#ccc' }}>
              ★
            </span>
            <span style={{ color: review.score >= 5 ? '#ffd700' : '#ccc' }}>
              ★
            </span>
          </span>
        )}
      </p>
      <p
        className="text-fz-14px text-black-50 pb-0 mb-0"
        style={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: '100%',
          textOverflow: 'ellipsis',
        }}
      >
        {review.event && review.event.event_date_disp}
        {'　'}
        {review.event && (
          <a
            className="text-fz-14px text-black-50 inline-block"
            href={`/event/${review.event.id}/reports/${review.id}`}
          >
            {review.event.title + 'に参加'}
          </a>
        )}
      </p>
      <p className="text-fz-14px pt-2 mb-0">{review.description}</p>
      <div className="pl-3 pb-5">
        <ReviewComment
          reviewId={review.id}
          currentUser={currentUser}
          isFormShow={isFormShow}
        />
      </div>
      <ModalConfirm
        ref={confirmModalRef}
        title="通報します。"
        content="よろしいですか？"
        approveFunc={() => {
          axios
            .post('/api/events_reports_violations', {
              events_report_id: review.id,
            })
            .then(() => {
              alertModalRef.current.openModal();
            });
        }}
        rejectFunc={() => {}}
      />
      <ModalAlert
        ref={alertModalRef}
        id="modalAlert"
        title="通報が完了しました。"
        content=""
      />
      <ModalConfirm
        ref={deleteConfirmModalRef}
        title="削除します。"
        content="よろしいですか？"
        approveFunc={() => {
          axios.delete(`/api/circles_reviews/${review.id}`).then(() => {
            deleteAlertModalRef.current.openModal();
          });
        }}
        rejectFunc={() => {}}
      />
      <ModalAlert
        ref={deleteAlertModalRef}
        id="modalAlert"
        title="削除が完了しました。"
        content=""
        approveFunc={() => setIsDeleted(true)}
      />
      {/* @context TGW-2035 管理人による他人のレビュー削除は濫用抑止のため抑制文言を付けた専用モーダルにする。
          本人削除(上のdeleteConfirmModalRef)とは文言・対象ボタンが異なるため別コンポーネントとして分離。 */}
      <ModalConfirm
        ref={managerDeleteConfirmModalRef}
        title="削除します。"
        content={
          <>
            よろしいですか？
            <br />
            <span className="text-danger">
              ※削除した内容は運営チームに送られます。
            </span>
          </>
        }
        approveFunc={() => {
          axios.delete(`/api/circles_reviews/${review.id}`).then(() => {
            managerDeleteAlertModalRef.current.openModal();
          });
        }}
        rejectFunc={() => {}}
      />
      <ModalAlert
        ref={managerDeleteAlertModalRef}
        id="modalAlert"
        title="削除が完了しました。"
        content=""
        approveFunc={() => setIsDeleted(true)}
      />
    </li>
  );
};

export default Review;
